{
  "global": {
    "overview": "Overview",
    "view_image": "View image",
    "view_image_title": "View image: {title}",
    "view_project": "View project",
    "ua": "UA",
    "usd": "USD"
  },
  "nav": {
    "adfcycles": "ADF Cycles",
    "afawa": "Afawa",
    "afdb": "African Development Bank Group",
    "by_adfcycles": "By ADF Cycles",
    "by_country": "By Country & Region",
    "by_current_status": "By Current Status",
    "by_financing": "By Sources of Financing",
    "by_high5": "By High 5",
    "by_instrument": "By Financial Instrument",
    "by_media": "By Media",
    "by_project_type": "By Project Type",
    "by_sector": "By Sector",
    "by_sovereign": "Sovereign / Non-sovereign",
    "by_status": "By Status",
    "by_year_type": "By Project Event",
    "by_year": "By one or more years",
    "clear_filters": "Clear Filters",
    "countries": "Countries & Regions",
    "demo": "This is a demo site currently under development",
    "done": "Done",
    "filters": "Filters",
    "financing": "Sources of Financing",
    "green_bond": "Green Bond",
    "has_document": "Document",
    "has_image": "Image",
    "has_story": "Story",
    "high5s": "High 5s",
    "home": "Home",
    "in": "in",
    "mapafrica": "MapAfrica",
    "m300": "Mission 300",
    "non_sovereign": "Non-sovereign",
    "pages": "Pages",
    "projects": "Projects",
    "results": "Results",
    "search": "Search",
    "sectors": "Sectors",
    "social_bond": "Social Bond",
    "sovereign": "Sovereign",
    "status_approved": "Approved",
    "status_cancelled": "Cancelled",
    "status_completed": "Completed",
    "status_ongoing": "Ongoing",
    "year_type_approved": "Approved",
    "year_type_completed": "Completed",
    "year_type_planned": "Planned Completion",
    "year_type_signed": "Signed"
  },
  "locale": {
    "en": "English",
    "fr": "Français"
  },
  "home": {
    "approval_date": "Approval Date",
    "commitment": "Commitment",
    "csv": "CSV",
    "description": "Explore African Development Bank funded activities",
    "download": "Export data",
    "end_date": "End date",
    "iati_identifier":"IATI identifier",
    "identifier":"Project code",
    "json": "JSON",
    "map_title": "Map of all projects",
    "multinational": "Multinational",
    "none_selected": "None selected",
    "projects": "Projects",
    "project_title": "Title",
    "project_country": "Country",
    "sector": "Sector",
    "sovereign_non": "Sovereign / Non Sovereign",
    "status": "Status",
    "title": "Overview",
    "unknown": "Unknown",
    "xlsx": "XLSX",
    "xml": "XML"
  },
  "map": {
    "approved": "Approved",
    "at": "at",
    "commitment": "Commitment",
    "download": "Download image",
    "generated_on": "Generated on",
    "generating": "Generating...",
    "legend": "Legend",
    "multiple_themes": "Multiple themes",
    "print": "Print",
    "project": "project",
    "projects": "projects",
    "reset": "Reset",
    "sector": "Sector",
    "status": "Status"
  },
  "stats": {
    "macro_gdp": "GDP",
    "macro_gdp_capita": "GDP per capita",
    "macro_life_expectancy": "Life expectancy at birth, total (years)",
    "macro_population": "Population, total",
    "projects": "Number of Projects",
    "status_approved": "Approved",
    "status_cancelled": "Cancelled",
    "status_completed": "Completed",
    "status_ongoing": "Ongoing",
    "total_commitments": "Total Commitments",
    "total_country": "Country Specific",
    "total_multi": "Multinational Portfolio"
  },
  "middle": {
    "in_million_ua": "in UA million",
    "in_million_usd": "in USD million",
    "multinational": "Multinational",
    "top_countries": "Countries",
    "top_sectors": "Sectors",
    "top_sources": "Top Sources of Financing",
    "top_themes": "High 5s",
    "unknown": "Unknown"
  },
  "countries": {
    "description": "Explore African Development Bank funded activities in {country}",
    "documents": "Documents",
    "images": "Images",
    "map_title_countries": "Map of projects by country",
    "map_title_regions": "Map of projects by region",
    "play_video": "Play video: {title}",
    "videos": "Videos"
  },
  "sectors": {
    "description": "Explore African Development Bank funded activities in the {sector} sector",
    "map_title": "Map of projects by sector"
  },
  "results": {
    "country": "Country",
    "delivered": "Actual",
    "expected": "Planned",
    "high_5": "High 5",
    "indicator_name": "Indicator Name",
    "results_management_framework": "Results Management Framework",
    "sector": "Sector",
    "of": "of",
    "nav": {
      "results": "Results",
      "delivered2024": "Results delivered in 2024",
      "tys": "Tracking the Ten Year Strategy",
      "historical": "Results delivered 2011-2025",
      "m300": "Mission 300: Progress Tracker"
    },
    "documents": {
      "rmf": "Results Management Framework",
      "adf": "ADF Delivery and Results Report",
      "ader": "Annual Development Effectiveness Reviews",
      "cder": "Country Development Effectiveness Reviews",
      "tder": "Thematic Development Effectiveness Reviews"
    },
    "countries": "Countries",
    "projects": "Projects",
    "project": "Project",
    "years": "Years",
    "top5Countries": "Top 5 Countries",
    "showingDataFor": "Showing data for",
    "fromTo": " – ",
    "byYear": "By Year",
    "viewDetails": "View details →"
  },
  "m300": {
    "supplySystem": "Supply System",
    "connectionType": "Connection Type",
    "indicator": "Indicator",
    "m300Indicators": "M-300 Indicators",
    "totalProjects": "Total Projects",
    "progress": "Progress",
    "delivered": "Delivered",
    "target": "Target",
    "underImplementation": "Under Implementation",
    "remaining": "Remaining",
    "additionalIndicators": "Additional indicators (projects completed since 2015)",
    "projectLocations": "Project locations",
    "peopleProvidedWithAccessToElectricity": "People provided with new electricity connections",
    "byRegion": "By Region:",
    "byCountry": "By Country:",
    "projects": "Projects",
    "total": "Total",
    "onGrid": "On-Grid",
    "offGrid": "Off-Grid",
    "miniGrid": "Mini-Grid",
    "households": "Households",
    "businesses": "Businesses",
    "publicServices": "Public Services",
    "noData": "No data available for the selected filters.",
    "metrics": {
      "peopleProvided": {
        "delivered": "People provided with new electricity connections",
        "expected": "People to be connected"
      },
      "numberConnections": {
        "delivered": "Number of electricity connections",
        "expected": "Expected additional electricity connections"
      },
      "powerCapacityInstalled": {
        "delivered": "Power capacity installed (MW)",
        "expected": "Expected additional power capacity (MW)"
      },
      "transmissionLines": {
        "delivered": "Cross-border and National Transmission Lines (KM)",
        "expected": "Expected additional transmission lines (KM)"
      },
      "distributionLines": {
        "delivered": "New or improved power distribution lines (KM)",
        "expected": "Expected new or improved power distribution lines (KM)"
      }
    }
  },
  "tys": {
    "expected_since_2024": "Expected results from approvals since 2024",
    "target_2033": "2033 Target",
    "ambition": "Proposed level of ambition 2033",
    "ambition_subtitle": "Aggregate expected results from PARs approved during 2024-2033",
    "legend_text": "Expected results from 2024 approvals:",
    "on_track": "On Track",
    "off_track": "Off Track",
    "millions": "Millions"
  },
  "projects": {
    "adf_cycle": "ADF Cycle",
    "afdb_group": "African Development Bank Group",
    "afawa": "Afawa",
    "aid_type": "Aid Type",
    "approval_date": "Approval Date",
    "baseline": "Baseline",
    "baseline_year": "Baseline Year",
    "baseline_value": "Baseline Value",
    "beneficiaries": "Beneficiaries",
    "climate_safeguards_cat": "Climate Safeguards Categorization",
    "cofinancing": "Co-financing",
    "commitment": "Commitment",
    "commitments": "Commitments",
    "commitments_by_source": "Commitments by source",
    "contact_details": "Contact Details",
    "country": "Country",
    "dac_sector_code": "DAC Sector Code",
    "date": "Date",
    "disbursed": "Disbursed",
    "disbursement": "Disbursement",
    "disbursements": "Disbursements",
    "docs_1": "Appraisal Report",
    "docs_2": "Contract",
    "docs_3": "Environmental Study",
    "docs_4": "Evaluation Report",
    "docs_5": "Project-related Procurement",
    "docs_6": "Memorandum of Understanding",
    "docs_7": "Project Completion Report",
    "documents": "Documents",
    "email": "Email",
    "end_date": "End date",
    "environmental_cat": "Environmental Category",
    "export": "Export",
    "finance_id": "Masterloan number",
    "finance_type": "Finance Type",
    "financial_information": "Financial information",
    "financial_instrument": "Financial Instrument",
    "financial_instruments": "Financial Instruments",
    "financing": "Financing",
    "flow_type": "Flow Type",
    "fragility_lens_assessment": "Fragility Lens Assessment",
    "gender_marker_system_cat": "Gender Marker System Categorization",
    "geographic_location": "Geographic Location",
    "green_bond": "Green Bond",
    "government": "Government",
    "iati_identifier": "IATI identifier",
    "images": "Images",
    "indicator": "Indicator",
    "indicator_actual": "Actual",
    "indicator_ascending": "Indicator is ascending (improves from small to large, e.g. clinics built)",
    "indicator_descending": "Indicator is descending (improves from large to small, e.g. cases of a disease)",
    "indicator_measure": "Indicator Measure",
    "indicator_target": "Planned",
    "indicator_period": "Period",
    "indicator_title": "Notes",
    "info": "Information",
    "interest": "Interest Payments",
    "last_disbursement": "Project Completion Report Date",
    "loading": "Loading...",
    "loans": "Loan Repayments",
    "location": "Location",
    "name": "Name",
    "noProgress": "–",
    "no_results": "No results",
    "non_sovereign": "Non-sovereign",
    "overview": "Overview",
    "participating_org": "Participating Organizations",
    "percentage_commitments_disbursed": "% of commitments disbursed",
    "percentage_total_commitments": "% of total commitments",
    "planned": "planned",
    "progress": "Progress",
    "project_classification": "Project Classification",
    "planned_completion_date": "Planned Completion Date",
    "project_general_description": "Project General Description",
    "project_objectives": "Project Objectives",
    "project_search": "Project search",
    "project_summary": "Project Summary",
    "project_type": "Project Type",
    "provider": "Provider",
    "qualitative_results": "Qualitative results",
    "quantitative_results": "Quantitative results",
    "results": "Results",
    "search": "Search",
    "search_for_project": "Search for a project",
    "search_results": "Search Results",
    "sector": "Sector",
    "signature_date": "Signature Date",
    "social_bond": "Social Bond",
    "sovereign": "Sovereign",
    "sovereign_non_sovereign": "Sovereign / Non-Sovereign",
    "start_date": "Start date",
    "status": "Status",
    "stories": "Stories",
    "theme": "High 5",
    "topics": "Topics",
    "total_project_cost": "Total project cost",
    "total_all_sources": "Total committed across all financing sources",
    "totals": "Totals",
    "transaction_date": "Date",
    "unknown": "Unknown",
    "untitled": "Untitled",
    "value": "Value"
  },
  "footer": {
    "afdb": "African Development Bank Group",
    "disclosure_1": "Disclosure and Access to Information",
    "disclosure_2": "Independent Recourse Mechanism",
    "disclosure_3": "About this data",
    "disclosure_html_1": "Do you have a concern about a Bank-financed project? Individuals, workers and communities who are (or may be) adversely impacted by AfDB-financed projects are encouraged to contact the project-level grievance mechanism or submit their complaints to the",
    "disclosure_html_2": "Independent Recourse Mechanism (IRM)",
    "disclosure_html_3": "The",
    "disclosure_html_4": "Disclosure and Access to Information (DAI) policy",
    "disclosure_html_5": "is a reaffirmation of the Bank Group’s commitment, to carry out its development activities in an open and transparent manner. The policy is grounded on the principles of good governance, particularly transparency, accountability and sharing of information in its operations. It establishes the disclosure requirements for documents and information the AfDB produces or requires to be produced",
    "disclosure_html_6": "Conversions to USD are based on IMF exchange rates as of the end of the month corresponding to the value date.",
    "disclosure_html_7": "Data provided under",
    "disclosure_html_8": "Creative Commons Attribution",
    "disclosure_html_9": " licence",
    "disclosure_url_1": "https://irm.afdb.org/",
    "disclosure_url_2": "https://www.afdb.org/en/disclosure-and-access-to-information",
    "disclosure_url_3": "https://creativecommons.org/licenses/by/4.0/deed.en",
    "glossary": "Glossary",
    "rss": "RSS Feeds",
    "sitemap": "Sitemap",
    "terms": "Terms & Conditions",
    "timestamp": "Last updated"
  }
}
